// extracted by mini-css-extract-plugin
export var bpdp = "blog-pdp-module--bpdp--f8fe4";
export var cta = "blog-pdp-module--cta--a66ec";
export var gall = "blog-pdp-module--gall--c99ba";
export var head = "blog-pdp-module--head--e442f";
export var info = "blog-pdp-module--info--e9a6e";
export var loading = "blog-pdp-module--loading--c7825";